import useSWR from 'swr';

import {
  FETCH_RECNCLN_MERCHANT_ACCOUNT,
  fetchMerchantAccount,
} from 'SRC/fetch/api/reconciliation';

export const useFetchRecnclnMe = () => {
  const { data, error, isLoading } = useSWR(
    FETCH_RECNCLN_MERCHANT_ACCOUNT,
    fetchMerchantAccount,
  );

  return {
    data,
    error,
    isLoading,
  };
};
